import { useState } from "react";
import { cleanRut, formatRut, isValidRut } from "../lib/rut";

/**
 * Input controlado para RUT chileno.
 *  - Acepta solo dígitos y K.
 *  - Formatea con puntos y guión mientras el usuario escribe.
 *  - Devuelve el valor formateado vía `onChange(rutFormateado)`.
 *  - Muestra error si el RUT es inválido (al perder foco o al escribir
 *    una vez que tiene 8+ caracteres).
 */
export default function RutInput({
  value,
  onChange,
  placeholder = "12.345.678-K",
  className = "",
  testId,
  required = false,
}) {
  const [touched, setTouched] = useState(false);
  const display = formatRut(value || "");
  const clean = cleanRut(value || "");
  const showError = (touched || clean.length >= 8) && clean.length > 0 && !isValidRut(value);

  return (
    <div>
      <input
        type="text"
        inputMode="text"
        autoComplete="off"
        value={display}
        placeholder={placeholder}
        data-testid={testId}
        onChange={(e) => onChange(formatRut(e.target.value))}
        onBlur={() => setTouched(true)}
        className={`${className} ${showError ? "border-[#9B1C1C]" : ""}`}
        aria-invalid={showError || undefined}
      />
      {showError && (
        <div className="text-[10px] text-[#FF7A7A] mt-1 font-mono uppercase tracking-widest">
          RUT inválido
        </div>
      )}
      {required && !clean && touched && (
        <div className="text-[10px] text-[#FF7A7A] mt-1 font-mono uppercase tracking-widest">
          RUT requerido
        </div>
      )}
    </div>
  );
}
